import { render, staticRenderFns } from "./CheckoutNewUserAddresses.vue?vue&type=template&id=7f2a1740"
import script from "./CheckoutNewUserAddresses.vue?vue&type=script&lang=js"
export * from "./CheckoutNewUserAddresses.vue?vue&type=script&lang=js"
import style0 from "./CheckoutNewUserAddresses.vue?vue&type=style&index=0&id=7f2a1740&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports